import React, { useState, useRef } from 'react'

import axios from 'axios'

import logo from '../Assets/Kabakoo.png'
import loader from '../Assets/loading.svg'


import './style.css'
import { main_end_point } from '../config/baseUrl';
import { checkInputLength, getLocalStorageData, handleDataStructure, urlConfiguration } from '../config/helpers';
import copyright from '../config/copyright.json'
import Loader from './Loader'


function SignUp({ componentDidMount }) {

    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
    });
    const [firstname, setFirstname] = useState({ 'isOk': false, 'value': '' });
    const [lastname, setLastname] = useState({ 'isOk': false, 'value': '' })

    const [error, setError] = useState({ 'is': false, 'message': '' })
    const [load, setLoad] = useState(false)


    const handleInputChange1 = (event) => {
        const value = event.target.value
        let isOk = checkInputLength(value)
        if (isOk) {
            setFirstname({
                'isOk': true,
                'value': value
            })
        } else {
            setFirstname({
                'isOk': false,
                'value': value
            })
        }
    };
    const handleInputChange2 = (event) => {
        const value = event.target.value
        let isOk = checkInputLength(value)
        if (isOk) {
            setLastname({
                'isOk': true,
                'value': value
            })
        } else {
            setLastname({
                'isOk': false,
                'value': value
            })
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoad(true)
        let storeData = getLocalStorageData().kaba_info
        let hashed_phone = storeData.neguediourou
        let otp_id = storeData.one_time_password.one_time_password_id
        let otp = storeData.one_time_password.one_time_password
        let source = storeData.source
        let device_id = storeData.device_id


        // Utilisez Axios pour envoyer les données du formulaire au backend
        let data = {
            'hashed_phone': hashed_phone,
            'otp_id': otp_id,
            'otp': otp,
            'firstname': firstname.value,
            'lastname': lastname.value
        }

        // Ajouter device_id seulement s'il existe
        if (device_id) {
            data.device_id = device_id;
        }

        axios.post(`${main_end_point}/create_account/`, data)
            .then((response) => {
                // Traitez la réponse du backend si nécessaire
                let kaba_token = response.data.token
                handleDataStructure('kabakoo.africa.token', kaba_token)
                handleDataStructure("signin", '')
                componentDidMount(5)
                // on redirige l'apprenant
                window.location.href = urlConfiguration(hashed_phone, kaba_token, source)
            })
            .catch((error) => {
                // console.log(error.response);
                // Gérez les erreurs si nécessaire
                let code = error.response.data.code
                setError({ 'is': true, 'message': copyright.create_account[`${code}`] })
                setLoad(false)
            });
    };
    return (
        <div>

            <div className='heading'>
                <div className="logo">
                    <div className="image">
                        <img src={logo} alt="logo" />
                    </div>
                </div>
                <div className="title">
                    <h4>{copyright.creation_compte.titre}</h4>
                    <p>{copyright.creation_compte.info} </p>
                </div>

            </div>

            <div className="form">

                <form method="post" onSubmit={handleSubmit} style={{ opacity: 1 }}>
                    <div className="input-block">
                        <input
                            type="text"
                            name="lastname"
                            id="lastname"
                            placeholder="Prénom"
                            value={lastname.value}
                            onChange={handleInputChange2}
                        />
                    </div>

                    <div className="input-block">
                        <input
                            type="text"
                            name="firstname"
                            id="firstname"
                            placeholder="Nom"
                            value={firstname.value}
                            onChange={handleInputChange1}
                        />
                    </div>

                    <div className="button input-block ">
                        {
                            load ?
                                <Loader img={loader} />
                                :
                                firstname.isOk && lastname.isOk
                                    ? <input type="submit" value="Continuer" />
                                    : <input type="button" value="Continuer" style={{ opacity: 0.3 }} />
                        }

                    </div>
                    <div className="error">
                        {error.is && <p>{error.message}</p>}
                    </div>
                </form>
            </div>
        </div>

    )
}

export default SignUp